// extracted by mini-css-extract-plugin
export default {"title":"z--z","warning":"A--z","sizeOptionsLegendText":"B--z"};